"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./defineProperty-b53f90b9.js"),
  t = require("./slicedToArray-a539bf82.js"),
  n = require("react"),
  a = require("prop-types"),
  r = require("styled-components"),
  i = require("./grid-965d799c.js"),
  l = require("./typography-fb2881fe.js"),
  o = require("./taggedTemplateLiteral-97b463ad.js"),
  s = require("polished/lib/helpers/rem"),
  c = require("./foundations/Icon/icons/utility/ChevronLeftNarrow.js"),
  d = require("./foundations/Icon/icons/utility/ChevronRightNarrow.js"),
  u = require("./style-inject.es-dcee06b6.js");
function p(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var m,
  f,
  g,
  y,
  b,
  h,
  w,
  v,
  E,
  x,
  k,
  L,
  Q = p(n),
  j = p(a),
  N = p(r),
  F = p(s),
  R = N["default"](i.Row)(m || (m = o._taggedTemplateLiteral(["\n  && {\n    width: 100%;\n    height: 100%;\n    padding-bottom: ", ";\n  }\n"])), F["default"](40)),
  T = N["default"].div(f || (f = o._taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"]))),
  C = N["default"](i.Row)(g || (g = o._taggedTemplateLiteral(["\n  width: 100%;\n  justify-content: center;\n"]))),
  U = N["default"](i.Col)(y || (y = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = "0 100%",
      n = "100%";
    return e.theme.smallUp() && (t = "0 83.33333333333334%", n = "83.33333333333334%"), r.css(b || (b = o._taggedTemplateLiteral(["\n      flex: ", ";\n      max-width: ", ";\n    "])), t, n);
  }),
  D = N["default"].div(h || (h = o._taggedTemplateLiteral(["\n  && {\n    width: 100%;\n    bottom: 0;\n  }\n"]))),
  S = N["default"].div(w || (w = o._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme,
      n = t.smallUp();
    return r.css(v || (v = o._taggedTemplateLiteral(["\n    && {\n      display: block;\n      width: ", ";\n      height: ", ";\n      top: ", ";\n      background-color: ", ";\n      &::after {\n        color: ", ";\n        visibility: hidden;\n      }\n    }\n  "])), F["default"](17), n ? "unset" : "100%", n ? "45%" : 0, n ? "unset" : "rgba(255,255,255,0.3)", t.colors.neutral.grayDark10);
  }),
  O = N["default"](c)(E || (E = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return r.css(x || (x = o._taggedTemplateLiteral(["\n    .icon-stroke {\n      fill: none; /** TODO: reexamine build-icons to handle svg polyline stroke and fill */\n      stroke: ", ";\n    }\n    :hover {\n      .icon-stroke {\n        stroke: ", ";\n      }\n    }\n  "])), t.colors.neutral.gray, t.colors.action.lightTheme.linkHover);
  }),
  J = N["default"](d)(k || (k = o._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return r.css(L || (L = o._taggedTemplateLiteral(["\n    .icon-stroke {\n      fill: none; /** TODO: reexamine build-icons to handle svg polyline stroke and fill */\n      stroke: ", ";\n    }\n    :hover {\n      .icon-stroke {\n        stroke: ", "; /** switched from linkDefault to linkHover - Confirm with Creative */\n      }\n    }\n  "])), t.colors.neutral.gray, t.colors.action.lightTheme.linkHover);
  });
function B(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function W(t) {
  for (var n = 1; n < arguments.length; n++) {
    var a = null != arguments[n] ? arguments[n] : {};
    n % 2 ? B(Object(a), !0).forEach(function (n) {
      e._defineProperty(t, n, a[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : B(Object(a)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(a, e));
    });
  }
  return t;
}
u.styleInject(".swiper-pagination-bullet{background-color:#ccc;margin:0 10px;opacity:1}.swiper-pagination-bullet-active{background-color:#1570bc}@media (min-width:48.0625em){.swiper-slide .nmx-col-small-10{flex:0 83.3333333333%;max-width:83.3333333333%}}.video-container{height:0;padding-bottom:56.25%;position:relative}.video-container iframe{height:100%;left:0;position:absolute;top:0;width:100%}.swiper-button-next.swiper-button-next{left:unset;right:0}.swiper-button-prev.swiper-button-prev{margin-left:-2px}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZpbGU6Ly8vYnVpbGRzL25teC9saWJyYXJpZXMvbm14LXRlbXBsYXRlL3NyYy9jb21wb25lbnRMaWJyYXJ5L21vZHVsZXMvQ2Fyb3VzZWwvY2Fyb3VzZWwuc2NzcyIsImNhcm91c2VsLnNjc3MiLCJmaWxlOi8vL2J1aWxkcy9ubXgvbGlicmFyaWVzL25teC10ZW1wbGF0ZS9zcmMvYXNzZXRzL3Njc3Mvc2V0dGluZ3MvYnJlYWtwb2ludHMuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTRSwwQkFFRSxxQkFBQSxDQURBLGFBQUEsQ0FFQSxTQ1JKLENEVUksaUNBQ0Usd0JDUk4sQ0N5RkksNkJGMUVGLGdDQUVJLHFCQUFBLENBQ0Esd0JDWkosQ0FDRixDRGdCQSxpQkFFRSxRQUFBLENBQ0EscUJBQUEsQ0FGQSxpQkNYRixDRGNFLHdCQUtFLFdBQUEsQ0FGQSxNQUFBLENBRkEsaUJBQUEsQ0FDQSxLQUFBLENBRUEsVUNYSixDRGlCRSx1Q0FFRSxVQUFBLENBREEsT0NiSixDRG1CRSx1Q0FDRSxnQkNoQkoiLCJmaWxlIjoiY2Fyb3VzZWwuc2NzcyJ9 */");
var I = function I(e) {
  var a = e["data-static-config"],
    r = n.useState(!1),
    o = t._slicedToArray(r, 2),
    s = o[0],
    c = o[1],
    d = n.useRef(),
    u = n.useState(!1),
    p = t._slicedToArray(u, 2),
    m = p[0],
    f = p[1];
  return n.useEffect(function () {
    var e = document.createElement("script");
    e.src = "https://unpkg.com/swiper@6.7.0/swiper-bundle.min.js", e.integrity = "sha384-Y1O5WrIEuc9IhTQYuX3AAtW4jNhdPW/kGCjE/AyulARrGXpDMJYi1WD6UIllTfJ0", e.crossOrigin = "anonymous", e.async = !0, document.body.appendChild(e), e.onload = function () {
      c(!0);
    };
    var t = document.createElement("link");
    t.href = "https://unpkg.com/swiper@6.7.0/swiper-bundle.min.css", t.rel = "stylesheet", t.integrity = "sha384-hJBk1nqEF9yHIQHQ6cqCLBxzW+Eb4zV4S04M5kR/dG4EDiYTLEoBjGCKD3y5DDlK", t.crossOrigin = "anonymous", document.body.appendChild(t);
  }, []), n.useEffect(function () {
    if (m && s) {
      var e = d.current.autoplay ? {
        autoplay: {
          delay: d.current.autoplayDelay
        }
      } : {};
      new Swiper(".swiper-container", W(W({
        slidesPerView: 1,
        centeredSlides: !0,
        grabCursor: !0
      }, e), {}, {
        speed: 400,
        loop: !0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: !0,
          type: "bullets"
        },
        on: {
          slideChange: function slideChange() {
            var e = this.slides[this.previousIndex] ? this.slides[this.previousIndex].querySelectorAll("iframe")[0] : void 0;
            e && e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "https://www.youtube.com");
          }
        }
      }));
    }
  }, [m, s]), n.useEffect(function () {
    a && s && (d.current = a.swiperCarousel, f(!0));
  }, [s]), m && Q["default"].createElement(Q["default"].Fragment, null, d.current.sectionHeading && Q["default"].createElement(l.TypographyComponent, {
    component: "h2",
    className: "nmx-assistive-text"
  }, d.current.sectionHeading), Q["default"].createElement(R, {
    className: "swiper-container"
  }, Q["default"].createElement(i.Col, {
    className: "nmx-section-thisSwiperCarousel-items swiper-wrapper"
  }, d.current.slides.map(function (e, t) {
    return Q["default"].createElement(T, {
      className: "swiper-slide",
      key: "".concat(e).concat(t + 1)
    }, Q["default"].createElement(C, null, Q["default"].createElement(U, {
      xsmall: 12,
      small: 10,
      className: "nmx-align-center nmx-col-small-10"
    }, e.data.heading && Q["default"].createElement(l.TypographyComponent, {
      variant: "h2"
    }, e.data.heading), e.data.text && Q["default"].createElement(l.TypographyComponent, {
      variant: "p",
      align: "left"
    }, e.data.text), Q["default"].createElement("div", {
      className: "video-container",
      "data-video-id": e.data.videoId
    }, Q["default"].createElement("iframe", {
      width: "600",
      height: "320",
      title: e.data.heading,
      src: "https://www.youtube.com/embed/".concat(e.data.videoId, "?enablejsapi=1"),
      frameBorder: "0",
      allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture;enablejsapi;",
      allowFullScreen: ""
    })))));
  })), Q["default"].createElement(S, {
    className: "swiper-button-prev"
  }, Q["default"].createElement(O, null)), Q["default"].createElement(S, {
    className: "swiper-button-next"
  }, Q["default"].createElement(J, null)), Q["default"].createElement(D, {
    className: "swiper-pagination"
  })));
};
I.propTypes = {
  "data-static-config": j["default"].object,
  "data-app-name": j["default"].string,
  "data-dynamic-config-base-url": j["default"].string
};
var G = r.withTheme(I);
exports.Carousel = G;